module.exports = __webpack_public_path__ + "img/login-3.e33071b8.png";